import AdaptiveTableExample from '@/dev-components/adaptive-table-example.vue';
import ButtonExample from '@/dev-components/button-example.vue';
import CheckboxExample from '@/dev-components/checkbox-example.vue';
import DevComponents from '@/dev-components/dev-components.vue';
import FormFieldExample from '@/dev-components/form-field-example.vue';
import ModalExample from '@/dev-components/modal-example.vue';
import NotificationExample from '@/dev-components/notification-example.vue';
import ProgressBarExample from '@/dev-components/progress-bar-example.vue';
import ToggleExample from '@/dev-components/toggle-example.vue';
import PageAccountWithoutCustomer from '@/pages/page-account-without-customer.vue';
import PageAccounts from '@/pages/page-accounts.vue';
import PageActivationOnWord from '@/pages/page-activation-on-word.vue';
import PageAdditionalServices from '@/pages/page-additional-services.vue';
import PageAdditionalStbDevices from '@/pages/page-additional-stb-devices.vue';
import PageAdditiveNetTopUp from '@/pages/page-additive-net-top-up.vue';
import PageAdditiveOverview from '@/pages/page-additive-overview.vue';
import PageAdditiveTariffOptions from '@/pages/page-additive-tariff-options.vue';
import PageApollonApp from '@/pages/page-apollon-app.vue';
import PageApollonUserGuide from '@/pages/page-apollon-user-guide.vue';
import PageApps from '@/pages/page-apps.vue';
import PageArenaCloudApp from '@/pages/page-arena-cloud-app.vue';
import PageArenaCloudUserGuide from '@/pages/page-arena-cloud-user-guide.vue';
import PageBalkanMusicApp from '@/pages/page-balkan-music-app.vue';
import PageBalkanMusicUserGuide from '@/pages/page-balkan-music-user-guide.vue';
import PageBillsOverview from '@/pages/page-bills-overview.vue';
import PageChangeEmailLinkExpired from '@/pages/page-change-email-link-expired.vue';
import PageChangeEmail from '@/pages/page-change-email.vue';
import PageChangePassword from '@/pages/page-change-password.vue';
import PageChangeTariffInternet from '@/pages/page-change-tariff-internet.vue';
import PageChangeTariffPostpaid from '@/pages/page-change-tariff-postpaid.vue';
import PageChangeTariff from '@/pages/page-change-tariff.vue';
import PageCombineNumbers from '@/pages/page-combine-numbers.vue';
import PageCombineTariffOptions from '@/pages/page-combine-tariff-options.vue';
import PageComplaints from '@/pages/page-complaints.vue';
import PageDeezerApp from '@/pages/page-deezer-app.vue';
import PageDeezerUserGuide from '@/pages/page-deezer-user-guide.vue';
import PageDeleteAccount from '@/pages/page-delete-account.vue';
import PageEBillsOverview from '@/pages/page-e-bills-overview.vue';
import PageFixedNumbers from '@/pages/page-fixed-numbers.vue';
import PageFixedTelephonyOverview from '@/pages/page-fixed-telephony-overview.vue';
import PageFixedTelephonyTariffOptions from '@/pages/page-fixed-telephony-tariff-options.vue';
import PageForgotPasswordLinkExpired from '@/pages/page-forgot-password-link-expired.vue';
import PageForgotPassword from '@/pages/page-forgot-password.vue';
import PageIncidentReport from '@/pages/page-incident-report.vue';
import PageInternetOverview from '@/pages/page-internet-overview.vue';
import PageIptvShop from '@/pages/page-iptv-shop.vue';
import PageKombinujOverview from '@/pages/page-kombinuj-overview.vue';
import PageKombinujTopUp from '@/pages/page-kombinuj-top-up.vue';
import PageLogin from '@/pages/page-login.vue';
import PageMobilePostpaidOverview from '@/pages/page-mobile-postpaid-overview.vue';
import PageMobilePrepaidOverview from '@/pages/page-mobile-prepaid-overview.vue';
import PageMsatAdditionalStbDevices from '@/pages/page-msat-additional-stb-devices.vue';
import PageMsatAddons from '@/pages/page-msat-addons.vue';
import PageMsatChannels from '@/pages/page-msat-channels.vue';
import PageMsatOverview from '@/pages/page-msat-overview.vue';
import PageMtelStoreApp from '@/pages/page-mtel-store-app.vue';
import PageNbaApp from '@/pages/page-nba-app.vue';
import PageNbaUserGuide from '@/pages/page-nba-user-guide.vue';
import PageNewPassword from '@/pages/page-new-password.vue';
import PageOverviewApps from '@/pages/page-overview-apps.vue';
import PageParking from '@/pages/page-parking.vue';
import PagePasswordChanged from '@/pages/page-password-changed.vue';
import PagePasswordConfirmation from '@/pages/page-password-confirmation.vue';
import PagePayForOther from '@/pages/page-pay-for-other.vue';
import PagePersonalOfferAdditive from '@/pages/page-personal-offer-additive.vue';
import PagePersonalOfferCombine from '@/pages/page-personal-offer-combine.vue';
import PagePersonalOfferFixed from '@/pages/page-personal-offer-fixed.vue';
import PagePersonalOfferInternet from '@/pages/page-personal-offer-internet.vue';
import PagePersonalOfferPostpaid from '@/pages/page-personal-offer-postpaid.vue';
import PagePersonalOfferPrepaid from '@/pages/page-personal-offer-prepaid.vue';
import PagePersonalOfferTv from '@/pages/page-personal-offer-tv.vue';
import PagePostpaidNumbers from '@/pages/page-postpaid-numbers.vue';
import PagePostpaidTariffOptions from '@/pages/page-postpaid-tariff-options.vue';
import PagePostpaidTopUp from '@/pages/page-postpaid-top-up.vue';
import PagePrepaidNumbers from '@/pages/page-prepaid-numbers.vue';
import PagePrepaidTopUp from '@/pages/page-prepaid-top-up.vue';
import PageRegistrationConfirmation from '@/pages/page-registration-confirmation.vue';
import PageRegistrationLinkExpired from '@/pages/page-registration-link-expired.vue';
import PageRegistration from '@/pages/page-registration.vue';
import PageSiguranNetApp from '@/pages/page-siguran-net-app.vue';
import PageSubmitRequest from '@/pages/page-submit-request.vue';
import PageTariffOptions from '@/pages/page-tariff-options.vue';
import PageTrustedLogin from '@/pages/page-trusted-login.vue';
import PageTvChannels from '@/pages/page-tv-channels.vue';
import PageTvOverview from '@/pages/page-tv-overview.vue';
import PageTvToGoConfirmation from '@/pages/page-tv-to-go-confirmation.vue';
import PageTvToGoSuccess from '@/pages/page-tv-to-go-success.vue';
import PageTvToGo from '@/pages/page-tv-to-go.vue';
import { constants } from '@/shared/constants';
import { addLocalRouteProp } from '@/shared/helpers';
import { urls } from '@/shared/urls';

export const routes = [
	{
		path: '/dev',
		component: DevComponents,
		children: [
			{
				path: 'button',
				component: ButtonExample,
			},
			{
				path: 'form-field',
				component: FormFieldExample,
			},
			{
				path: 'checkbox',
				component: CheckboxExample,
			},
			{
				path: 'notification',
				component: NotificationExample,
			},
			{
				path: 'modal',
				component: ModalExample,
			},
			{
				path: 'toggle',
				component: ToggleExample,
			},
			{
				path: 'progress-bar',
				component: ProgressBarExample,
			},
			{
				path: 'adaptive-table',
				component: AdaptiveTableExample,
			},
		],
	},
	{
		path: urls.login,
		component: PageLogin,
	},
	{
		path: urls.trustedLogin,
		component: PageTrustedLogin,
	},
	{
		path: urls.registration,
		component: PageRegistration,
	},
	{
		path: urls.changePassword,
		component: PageChangePassword
	},
	{
		path: urls.registrationConfirmation,
		component: PageRegistrationConfirmation,
	},
	{
		path: urls.registrationLinkExpired,
		component: PageRegistrationLinkExpired,
	},
	{
		path: urls.forgottenPassword,
		component: PageForgotPassword,
		...addLocalRouteProp({ captchaid: constants.reCaptchaTestKey })
	},
	{
		path: urls.passwordConfirmation,
		component: PagePasswordConfirmation,
	},
	{
		path: urls.forgottenPasswordLinkExpired,
		component: PageForgotPasswordLinkExpired,
	},
	{
		path: urls.newPassword,
		component: PageNewPassword,
	},
	{
		path: urls.passwordChanged,
		component: PagePasswordChanged,
	},
	{
		path: urls.linkedAccounts,
		component: PageAccounts
	},
	{
		path: urls.changeEmail,
		component: PageChangeEmail
	},
	{
		path: urls.changeEmailLinkExpired,
		component: PageChangeEmailLinkExpired
	},
	{
		path: urls.changePassword,
		component: PageChangePassword
	},
	{
		path: urls.deleteAccount,
		component: PageDeleteAccount
	},
	{
		path: urls.changeTariff,
		component: PageChangeTariff
	},
	{
		path: urls.topUp,
		component: PagePrepaidTopUp
	},
	{
		path: urls.mobilePrepaidOverview,
		component: PageMobilePrepaidOverview
	},
	{
		path: urls.tariffOptions,
		component: PageTariffOptions
	},
	{
		path: urls.mobilePostpaidOverview,
		component: PageMobilePostpaidOverview
	},
	{
		path: urls.postpaidTopUp,
		component: PagePostpaidTopUp
	},
	{
		path: urls.additionalServices,
		component: PageAdditionalServices
	},
	{
		path: urls.internetOverview,
		component: PageInternetOverview
	},
	{
		path: urls.kombinujOverview,
		component: PageKombinujOverview
	},
	{
		path: urls.kombinujTopUp,
		component: PageKombinujTopUp
	},
	{
		path: urls.additiveNetOverview,
		component: PageAdditiveOverview
	},
	{
		path: urls.additiveNetTopUp,
		component: PageAdditiveNetTopUp
	},
	{
		path: urls.changeTariffInternet,
		component: PageChangeTariffInternet
	},
	{
		path: urls.addService,
		component: PageAccountWithoutCustomer
	},
	{
		path: urls.combineTariffOptions,
		component: PageCombineTariffOptions
	},
	{
		path: urls.tvOverview,
		component: PageTvOverview
	},
	{
		path: urls.iptvShop,
		component: PageIptvShop
	},
	{
		path: urls.tvToGo,
		component: PageTvToGo
	},
	{
		path: urls.tvToGoConfirmation,
		component: PageTvToGoConfirmation
	},
	{
		path: urls.tvToGoSuccess,
		component: PageTvToGoSuccess
	},
	{
		path: urls.fixedTelephonyOverview,
		component: PageFixedTelephonyOverview
	},
	{
		path: urls.changeTariffPostpaid,
		component: PageChangeTariffPostpaid
	},
	{
		path: urls.fixedTelephonyTariffOptions,
		component: PageFixedTelephonyTariffOptions
	},
	{
		path: urls.additiveTariffOptions,
		component: PageAdditiveTariffOptions
	},
	{
		path: urls.postpaidTariffOptions,
		component: PagePostpaidTariffOptions
	},
	{
		path: urls.prepaidNumbers,
		component: PagePrepaidNumbers
	},
	{
		path: urls.combineNumbers,
		component: PageCombineNumbers
	},
	{
		path: urls.fixedNumbers,
		component: PageFixedNumbers
	},
	{
		path: urls.postpaidNumbers,
		component: PagePostpaidNumbers
	},
	{
		path: urls.additionalStbDevices,
		component: PageAdditionalStbDevices
	},
	{
		path: urls.billsOverview,
		component: PageBillsOverview
	},
	{
		path: urls.eBillsOverview,
		component: PageEBillsOverview
	},
	{
		path: urls.activationOnWord,
		component: PageActivationOnWord
	},
	{
		path: urls.payBillForAnother,
		component: PagePayForOther
	},
	{
		path: urls.tvChannels,
		component: PageTvChannels
	},
	{
		path: urls.parkingPrepaid,
		component: PageParking
	},
	{
		path: urls.parkingCombine,
		component: PageParking
	},
	{
		path: urls.parkingAdditive,
		component: PageParking
	},
	{
		path: urls.listOfApps,
		component: PageApps
	},
	{
		path: urls.personalOfferPrepaid,
		component: PagePersonalOfferPrepaid
	},
	{
		path: urls.personalOfferPostpaid,
		component: PagePersonalOfferPostpaid
	},
	{
		path: urls.personalOfferAdditive,
		component: PagePersonalOfferAdditive
	},
	{
		path: urls.personalOfferCombine,
		component: PagePersonalOfferCombine
	},
	{
		path: urls.personalOfferTv,
		component: PagePersonalOfferTv
	},
	{
		path: urls.personalOfferInternet,
		component: PagePersonalOfferInternet
	},
	{
		path: urls.personalOfferFixed,
		component: PagePersonalOfferFixed
	},
	{
		path: urls.nbaOverview,
		component: PageNbaApp
	},
	{
		path: urls.nbaUserGuide,
		component: PageNbaUserGuide
	},
	{
		path: urls.siguranNetOverview,
		component: PageSiguranNetApp
	},
	{
		path: urls.apollonOverview,
		component: PageApollonApp
	},
	{
		path: urls.apollonUserGuide,
		component: PageApollonUserGuide
	},
	{
		path: urls.balkanMusicOverview,
		component: PageBalkanMusicApp
	},
	{
		path: urls.balkanMusicUserGuide,
		component: PageBalkanMusicUserGuide
	},
	{
		path: urls.arenaCloudOverview,
		component: PageArenaCloudApp
	},
	{
		path: urls.arenaCloudUserGuide,
		component: PageArenaCloudUserGuide
	},
	{
		path: urls.deezerOverview,
		component: PageDeezerApp
	},
	{
		path: urls.deezerUserGuide,
		component: PageDeezerUserGuide
	},
	{
		path: urls.mtelStore,
		component: PageMtelStoreApp
	},
	{
		path: urls.request,
		component: PageSubmitRequest
	},
	{
		path: urls.complaint,
		component: PageComplaints
	},
	{
		path: urls.incident,
		component: PageIncidentReport
	},
	{
		path: urls.msatOverview,
		component: PageMsatOverview
	},
	{
		path: urls.msatChannels,
		component: PageMsatChannels
	},
	{
		path: urls.msatAddons,
		component: PageMsatAddons
	},
	{
		path: urls.msatAdditionalStbDevices,
		component: PageMsatAdditionalStbDevices
	},
	{
		path: urls.overviewAppsMsat,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsPrepaid,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsPostpaid,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsPostpaidPackage,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsInternet,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsCombine,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsAdditive,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsTv,
		component: PageOverviewApps
	},
	{
		path: urls.overviewAppsFixed,
		component: PageOverviewApps
	},
];

export default {
	isLoginPage(): boolean {
		return this.checkPage(urls.login);
	},
	isSpecialPages(pages: string[]): boolean {
		return pages.some((pageKey: string) => this.checkPage(urls[pageKey]));
	},
	checkPage(page: string): boolean {
		return window.location.pathname.toLowerCase().startsWith(page.toLowerCase());
	}
};
